import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ExportersApi } from 'api';

/**
 * Custom React Query hook that handles the creation of sellers.
 *
 * @param {"single" | "batch"} type
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import('@tanstack/react-query').UseMutationResult<any, unknown, any, unknown>}
 */
export function useCreateExporters(type = 'single', { onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      if (type === 'batch') {
        return ExportersApi.batchAdd(data);
      }

      return ExportersApi.add(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries(['exporters']);
      typeof onSuccess === 'function' && onSuccess(res.data);
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
